import React from "react";
import { THexColor, TViewHeight } from "../../../../models/StringLiterals";
import { TPixelSize } from "../../../../models/StringLiterals";
import { TPercentageSize } from "../../../../models/StringLiterals";

type TFullScreenViewProps = {
    width?: TPixelSize;
    height?: TPixelSize | TViewHeight | "auto";
    leftColor: THexColor;
    rightColor: THexColor;
    leftCutPoint: TPixelSize | TPercentageSize;
    rightCutPoint: TPixelSize | TPercentageSize;
};

export const FPTwoBackgroundFullScreenView = (props: React.PropsWithChildren<TFullScreenViewProps>): JSX.Element => {

    return (
        <div 
            className="fp-two-background-full-screen-view"
            style={{
                height: props.height || "95vh"
            }}
        >
            {/* BACKGROUND CUTS */}
            <div 
                className="
                    fp-two-background-full-screen-view__background-cut 
                    fp-two-background-full-screen-view__background-cut--left
                "
                style={{
                    backgroundColor: props.leftColor,
                }}
            />
            <div 
                className="
                    fp-two-background-full-screen-view__background-cut 
                    fp-two-background-full-screen-view__background-cut--right
                "
                style={{
                    backgroundColor: props.rightColor,
                }}
            />


            <div 
                className="fp-two-background-full-screen-view__body"
                style={{
                    width: props.width || "1200px"
                }}
            >
                <div 
                    className="
                        fp-two-background-full-screen-view__inner-cut 
                        fp-two-background-full-screen-view__inner-cut--left
                    "
                    style={{
                        backgroundColor: props.leftColor,
                        width: props.leftCutPoint,
                    }}
                />
                
                <div 
                    className="
                        fp-two-background-full-screen-view__inner-cut 
                        fp-two-background-full-screen-view__inner-cut--right
                    "
                    style={{
                        backgroundColor: props.rightColor,
                        width: props.rightCutPoint,
                    }}
                />

                <div className="fp-two-background-full-screen-view__content">
                    {props.children}
                </div>
            </div>
        </div>
    );
};
